import { Injectable } from '@angular/core';
import { DatabaseGwService } from '../database-gw.service';

@Injectable({
  providedIn: 'root'
})
export class SaleTransactionCountService extends DatabaseGwService {
  URL_PATH: string ='/sale-transaction-counts';


}
